'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './reservation-admin.routes';

export class ReservationAdminComponent {

  constructor(ReservationService, $uibModal, $timeout, Auth, $state, Config, dialogs) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.ReservationService = ReservationService;
    this.Auth = Auth;
    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$timeout  = $timeout;
    this.isAdmin = Auth.isAdminSync;

    this.reload = _ => $state.go("reservation-"+this.type+"-admin");

    var generalConfig = Config.getModuleConfig(Config.Modules.General);

    this.types = Config.getModuleConfig(Config.Modules.Reservation).getTypes();
    this.config = Config.getModuleConfig(Config.Modules.Reservation).getSettings();

    this.baseURL = Config.getPlatformConfig().getBaseUrl();

    if (this.config[this.type].hasOwnProperty("customSchema")) {
      this.customSchema = this.config[this.type].customSchema;
    }

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, this.config[this.type].name + " Reservation Review");

    this.typesEnum = [];
    this.types.forEach(type => {
      this.typesEnum.push({
        value: type,
        name: this.config[type].name
      })
    });

    this.timezone = generalConfig.getClientTimezone();

    var eventSourceTaken = {
      events: [],
      color: '#00aa00',
      textColor: 'white'
    };

    var eventSourceDeclined = {
      events: [],
      color: '#aa0000',
      textColor: 'white'
    };

    var eventSourceToBeApproved = {
      events: [],
      color: '#ffcc66',
      textColor: 'black'
    };

    this.eventSources.push(eventSourceTaken);
    this.eventSources.push(eventSourceToBeApproved);
    this.eventSources.push(eventSourceDeclined);

    this.takenIds = [];
    this.toBeApprovedIds = [];

    var that = this;

    var getData = function() {

      let count = 0;
      let doneHook = _ => {
        that.$timeout(_ =>{
          jQuery('#fullCalendar').fullCalendar('removeEvents');
          that.eventSources.forEach(eventSource => {
            jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
          });
        },0);
      };

      ReservationService.getByTypeAndState({type: that.type, state: 'accepted'}, data => {

        that.reservations = data;

        if (that.eventSources.length && that.eventSources[0].events.length) {
          that.eventSources[0].events.splice(0, that.eventSources[0].events.length);
        }

        data.forEach(evt => {
          let user = (evt.meta.creationUser) ? evt.meta.creationUser.shortName : "unknown";
          evt.title =  user + ": Accepted Reservation";
          evt.data = angular.copy(evt);
          that.eventSources[0].events.push(evt);
        });

        count++;
        if (count == 3)
          doneHook();

      }, err => {
        console.log('could not retrieve reservations from server');
      });

      ReservationService.getByTypeAndState({type: that.type, state: 'toBeApproved'}, data => {
        that.reviewReservations = data;

        if (that.eventSources.length && that.eventSources[1].events.length) {
          that.eventSources[1].events.splice(0, that.eventSources[1].events.length);
        }

        data.forEach(evt => {
          let user = (evt.meta.creationUser) ? evt.meta.creationUser.shortName : "unknown";
          evt.title =  user + ": Under Review";
          evt.data = angular.copy(evt);
          that.eventSources[1].events.push(evt);
        });

        count++;
        if (count == 3)
          doneHook();
      }, err => {
        console.log('could not retrieve reservations from server');
      });

      ReservationService.getByTypeAndState({type: that.type, state: 'declined'}, data => {
        if (that.eventSources.length && that.eventSources[2].events.length) {
          that.eventSources[2].events.splice(0, that.eventSources[2].events.length);
        }

        data.forEach(evt => {
          let user = (evt.meta.creationUser) ? evt.meta.creationUser.shortName : "unknown";
          evt.title =  user + ": Declined Reservation";
          evt.data = angular.copy(evt);
          that.eventSources[2].events.push(evt);
        });

        count++;
        if (count == 3)
          doneHook();
      }, err => {
        console.log('could not retrieve reservations from server');
      });
    };

    this.getData = getData;
    getData();

    this.uiConfig = {
      calendar: {
        defaultView: 'agendaWeek',
        allDaySlot: false,
        minTime: '06:00:00',
        slotDuration: '00:60:00',
        height: 'auto',
        timezone: 'local',
        header: {
          left: 'title',
          center: 'month,agendaWeek',
          right: 'today prev,next'
        },
       viewRender: (view, el) => {
         /* This is a hack, because the stick property of the event doesn't work with recurring events,
         so that these will appear multiple times per day - that's a bug.
         This hack solved the stick issue without using stick itself and thus corrupting recurring events:
         https://github.com/angular-ui/ui-calendar/issues/276 */

         jQuery('#fullCalendar').fullCalendar('removeEvents');
         this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
         })
        },
        eventRender: (event, el) => {
          // Timezone Difference Info
          var timeZoneDiffMin = this.getTimezoneDifference(this.timezone);

          var getTimezoneDiffString = function(mins) {
            var prefix = "+";
            if (mins < 0)
              prefix = "-";

            mins = Math.abs(mins);

            var h = mins / 60 | 0,
                m = mins % 60 | 0;

            if (String(h).length == 1)
              h = "0" + String(h);

            if (String(m).length == 1)
              m = "0" + String(m);

            return prefix + String(h) + ":" + String(m);
          };

          var timeZoneDiffStr = getTimezoneDiffString(timeZoneDiffMin);

          // render the timezone offset below the event title, if
          // user is in other timezone and the event is not all day
          if (!event.allDay && timeZoneDiffMin != 0) {
            el.find('.fc-title').after(
              jQuery('<div class="tzo text-muted"/>').text( timeZoneDiffStr )
            );
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          var that = this;

          var modalInstance = this.$uibModal.open({
            animation: true,
            component: 'reservationAdd',
            resolve: {
              config: function() {
                return {
                  isAdmin: that.Auth.isAdminSync(),
                  data: calendarEvent.data,
                  customSchema: that.customSchema
                }
              }
            }
          });

          modalInstance.result.then(
            function (editedEvent) {
              that.ReservationService.update({id: editedEvent._id}, editedEvent, _ => that.getData());
            },
            function () { /* cancel */ }
          );

        }
      }
    };
  }

  feedUrl() {
    let url = `${this.baseURL}/api/reservations/type/${this.type}/ical`
    prompt("You can subscribe to this calendar by adding this URL to your calendar app's feed list",url);
  }

  decline(reservation) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reasonForm',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (reason) {
        that.ReservationService.setState({id: reservation._id}, {state: 'declined', reason}, _ => that.getData());
      },
      function () { /* cancel */ }
    );

  }

  userContributionAllowed() {
    return this.calendarEventUserContributionAllowed
      && this.calendarEventUserContributionAllowed.indexOf(this.type) !== -1;
  }

  getTimezoneDifference(targetTimezone, userTimezone) {
    var now = moment();

    if (typeof userTimezone != 'undefined') {
      now = moment.tz(userTimezone);
    }

    var localOffset = now.utcOffset();

    now.tz(targetTimezone);

    var centralOffset = now.utcOffset();
    var diffInMinutes = localOffset - centralOffset;

    return diffInMinutes;
  }

  accept(reservation) {
    var that = this;

    var reservationText = "<br/><br/><b>" + moment(reservation.start).format('MMMM Do YYYY, h:mm')
      + "</b> till <b>" + moment(reservation.end).format('MMMM Do YYYY, h:mm') + "</b>";

    var dlg = this.dialogs.confirm("Accept Reservation?", "Do you want to accept this reservation?" + reservationText);
    dlg.result.then(() => {
      that.ReservationService.setState({id: reservation._id}, {state: 'accepted'}, _ => that.getData());
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduuApp.reservationAdmin', [uiRouter])
  .config(routes)
  .component('reservationAdmin', {
    template: require('./reservation-admin.html'),
    controller: ReservationAdminComponent,
    bindings: {
      type: '@'
    },
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/amenity/admin/reservation-admin.component.js